
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  display: inline-block;
  outline: none;
  height: 24px;
}
:host svg {
  max-width: 100%;
  outline: none;
}
:host .progress-circular-container {
  display: flex;
  position: relative;
}
:host .progress-circular-container span {
  line-height: 0;
  display: block;
}
:host .progress-circular-container span .circle-overlay {
  stroke: var(--slh-color-neutral-shade-20, #EBEEF4);
  fill: transparent;
}
:host .progress-circular-container span .icon {
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host .progress-circular-container span .circle-underlay {
  stroke: var(--slh-color-neutral-shade-20, #EBEEF4);
  fill: transparent;
}
:host .progress-circular-container .progress-circular-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
:host .progress-circular-container .progress-circular-content [name=large-text]::slotted(*) {
  display: block;
  font-size: var(--slh-base-xxl-font-size, 32px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  line-height: var(--slh-base-l-line-height, 56px);
  font-family: var(--slh-default-font-family, "Open Sans");
  color: var(--slh-color-success, #00B894);
}
:host .progress-circular-container .progress-circular-content [name=small-text]::slotted(*) {
  margin-top: -9px;
  display: block;
  color: var(--slh-color-neutral-shade-60, #62779F);
  font-size: var(--slh-base-xxs-font-size, 12px);
  font-weight: var(--slh-base-bold-font-weight, 700);
  line-height: var(--slh-base-xxs-line-height, 24px);
  font-family: var(--slh-default-font-family, "Open Sans");
}
:host .progress-circular-container.primary .circle-overlay {
  stroke: var(--slh-color-primary, #3B87D4);
}
:host .progress-circular-container.primary.type-success .icon {
  fill: var(--slh-color-primary, #3B87D4);
}
:host .progress-circular-container.info .circle-overlay {
  stroke: var(--slh-color-info, #74B9FF);
}
:host .progress-circular-container.info.type-success .icon {
  fill: var(--slh-color-info, #74B9FF);
}
:host .progress-circular-container.warning .circle-overlay {
  stroke: var(--slh-color-warning, #FDCB6E);
}
:host .progress-circular-container.warning.type-success .icon {
  fill: var(--slh-color-warning, #FDCB6E);
}
:host .progress-circular-container.success .circle-overlay {
  stroke: var(--slh-color-success, #00B894);
}
:host .progress-circular-container.success.type-success .icon {
  fill: var(--slh-color-success, #00B894);
}
:host .progress-circular-container.error .circle-overlay, :host .progress-circular-container.error .circle-underlay {
  stroke: var(--slh-color-neutral-shade-20, #EBEEF4);
  fill: transparent;
}
:host .progress-circular-container.error .icon {
  fill: var(--slh-color-error, #FF7E70);
}

:host([size=md]) {
  height: 32px;
}

:host([size=lg]) {
  height: 48px;
}

:host([size=xxl]) {
  height: 161px;
}

:host([size=sm]) .progress-circular-container .icon {
  fill: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host([size=sm]) .progress-circular-container .circle-underlay {
  stroke: var(--slh-color-neutral-shade-20, #EBEEF4);
  fill: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host([size=sm]) .progress-circular-container.type-success .icon {
  fill: var(--slh-color-neutral-shade-20, #EBEEF4);
}
:host([size=sm]) .progress-circular-container.success .icon {
  fill: var(--slh-color-success, #00B894);
}
:host([size=sm]) .progress-circular-container.success.type-success .circle-underlay {
  fill: var(--slh-color-neutral-shade-00, #FFFFFF);
  stroke: var(--slh-color-neutral-shade-20, #EBEEF4);
}
:host([size=sm]) .progress-circular-container.info .icon {
  fill: var(--slh-color-info, #74B9FF);
}
:host([size=sm]) .progress-circular-container.info.type-success .circle-underlay {
  stroke: var(--slh-color-info, #74B9FF);
}
:host([size=sm]) .progress-circular-container.warning .icon {
  fill: var(--slh-color-warning, #FDCB6E);
}
:host([size=sm]) .progress-circular-container.warning.type-success .circle-underlay {
  stroke: var(--slh-color-warning, #FDCB6E);
}
:host([size=sm]) .progress-circular-container.primary .icon {
  fill: var(--slh-color-primary, #3B87D4);
}
:host([size=sm]) .progress-circular-container.primary.type-success .circle-underlay {
  stroke: var(--slh-color-primary, #3B87D4);
}
:host([size=sm]) .progress-circular-container.type-error .circle-underlay {
  stroke: var(--slh-color-neutral-shade-20, #EBEEF4);
  fill: var(--slh-color-neutral-shade-20, #EBEEF4);
}
:host([size=sm]) .progress-circular-container.error .icon {
  fill: var(--slh-color-neutral-shade-00, #FFFFFF);
}
:host([size=sm]) .progress-circular-container.error .circle-underlay, :host([size=sm]) .progress-circular-container.error .circle-overlay {
  fill: var(--slh-color-error, #FF7E70);
  stroke: var(--slh-color-error, #FF7E70);
}
`;
